import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { FormSelect, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { handleAllError, handleErrorToast, ViewChatImageorFile } from "../CustomFunctions";
import { BASE_URL } from "../../config/axios";
import {
    AddwithBlueCircle,
    AddwithWhiteCircle,
    ArrowBullet,
    ArrowBulletHead,
    Attachment,
    Chats,
    CheckTick,
    CrossRed,
    DropdownArrow,
    DropdownArrowOption,
    Filter
} from "../AllSvg";
import { formatDateTime, formattedDate } from "../Date";
import ReactQuill from "react-quill";
import { useLocation } from "react-router-dom";
import { DocumentSection } from "../FormdataComponent";


const CompleteTask = ({ i, getAllTasks }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        completed_date: formattedDate,
        status: "completed",
        remark: "",
    });

    useEffect(() => {
        setFormData(i);
    }, [i]);

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["remark"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleFormSubmitPut = async (e) => {
        e.preventDefault();

        const updatedformvalue = {
            ...formData,
            completed_date: formattedDate,
            status: "completed",
        };

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.put(
                    `${BASE_URL}/wfm/task/${i.id}/`,
                    updatedformvalue
                );

                if (res.status === 200) {
                    await getAllTasks();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button
                className="model-edit-button-ml"
                title="Complete"
                onClick={handleShow}
            >
                <CheckTick />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Completing Remark</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className="parent-div">
                            <div className="flex-column">
                                {/* <label htmlFor="feedback" className="form-labels  font-weight500    font-size-subheading">
                                Closing Feedback<span className="required"></span>
                            </label> */}
                                <textarea
                                    type="text"
                                    id="remark"
                                    name="remark"
                                    maxLength={50}
                                    placeholder="remark"
                                    onChange={handleInputChange}
                                    value={formData.remark}
                                    className={`form-input-textarea   font-weight400  font-size-subheading ${errors.remark ? "error" : inputState.remark ? "success" : ""
                                        }`}
                                />
                                {errors.remarks && (
                                    <span className="error-message font-size-text ">
                                        {errors.remarks}
                                    </span>
                                )}
                            </div>

                            <div className="button-models">
                                <button
                                    className="model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Close
                                </button>
                                <button
                                    className="model-button   font-weight500    model-button-submit"
                                    onClick={handleFormSubmitPut}
                                    disabled={loading}
                                >
                                    Complete
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </Modal>
        </>
    );
};

const CloseTask = ({ i, getAllTasks }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        close_date: formattedDate,
        status: "close",
        feedback: "",
    });

    useEffect(() => {
        setFormData(i);
    }, [i]);

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["feedback"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleFormSubmitPut = async (e) => {
        e.preventDefault();
        const updatedformvalue = {
            ...formData,
            close_date: formattedDate,
            status: "close",
        };
        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.put(
                    `${BASE_URL}/wfm/task/${i.id}/`,
                    updatedformvalue
                );

                if (res.status === 200) {
                    await getAllTasks();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button
                className="model-delete-button"
                title="Close Task"
                onClick={handleShow}
            >
                <CrossRed />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Closing Feedback</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className="parent-div">
                            <div className="flex-column">
                                {/* <label htmlFor="feedback" className="form-labels  font-weight500    font-size-subheading">
                                Closing Feedback<span className="required"></span>
                            </label> */}
                                <textarea
                                    type="text"
                                    id="feedback"
                                    name="feedback"
                                    maxLength={100}
                                    placeholder="feedback"
                                    onChange={handleInputChange}
                                    value={formData.feedback}
                                    className={`form-input-textarea   font-weight400  font-size-subheading ${errors.feedback
                                        ? "error"
                                        : inputState.feedback
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.remarks && (
                                    <span className="error-message font-size-text ">
                                        {errors.remarks}
                                    </span>
                                )}
                            </div>

                            <div className="button-models">
                                <button
                                    className="model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Close
                                </button>
                                <button
                                    className="model-button   font-weight500    model-button-submit"
                                    onClick={handleFormSubmitPut}
                                    disabled={loading}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


const TaskChatboxModal = ({ i, clientemail, clientname, ticket_name, status, productname, usedIn }) => {

    const chatboxRef = useRef(null);
    const [chatShow, setChatShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChatOpen = (id) => {
        getTicketChat();
        setChatShow(true);
    };
    const email = sessionStorage.getItem('email');

    const handleChatClose = () => {
        setChatShow(false);
    };

    const [formData, setFormData] = useState({
        ticket_name: "",
        ticket: "",
        sender: sessionStorage.getItem('email'),
        sender_name: sessionStorage.getItem('name'),
        message: "",
        image: '',
        document: null,
        timestamp: new Date().toISOString(),
        ticketaccepted_by_email: "",
        ticketaccepted_by_name: "",
        ticket_for_productname: "",
        status: "",
        read_status: false,
        ticket_link: "https://www.cipl.aimantrahrms.com/"

    });

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            ticketaccepted_by_email: clientemail,
            ticketaccepted_by_name: clientname,
            ticket_name: ticket_name,
            ticket_for_productname: productname,
            ticket: i,
            ticket_link: "https://www.cipl.aimantrahrms.com/"

        }))
    }, [clientname, clientemail, ticket_name]);

    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;

        let newValue;
        console.log(value, 'newvalue')
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            if (files.length > 0) {
                newValue = files
            } else {
                newValue = null;
            }
        } else {
            newValue = value;
        }

        console.log(newValue)
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        // for removing error by clicking on input if any errors show 
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleFileChange = (e) => {
        const { name, value } = e.target;
        const file = e.target.files[0]

        if (file) {
            setFormData({ ...formData, [name]: file, });
            setFileName(file.name);
        } else {
            setFileName("");
        }

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }

    };
    const fileInputRef = useRef("");
    const handleClear = () => {
        setFormData(prevState => ({
            ...prevState,
            document: null
        }));
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [fileName, setFileName] = useState("");

    console.log(formData.files !== "")
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            formData.document !== null ? null : "message",
        ].filter(Boolean);
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        console.log("newErrors");
        console.log(newErrors);

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const [uploadProgress, setUploadProgress] = useState(0);

    const handleSendTaskRemark = async (e) => {

        if (e && e.preventDefault) {
            e.preventDefault();
        }

        console.log("formData");
        console.log(formData);

        if (validateForm()) {
            setLoading(true);
            // const loadingToastId = toast.loading("Loading: Please wait...");

            const formDataToSend = new FormData();
            Object.keys(formData).forEach((key) => {
                if (key !== "document") {
                    formDataToSend.append(key, formData[key]);
                }
            });

            const symbols = '!@#$%^&*()_-+=';
            const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz';
            const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const numbers = '0123456789';
            const now = new Date();
            let date = now.toLocaleDateString('en-GB').split('/').reverse().join('-'); // Format: YYYY-MM-DD
            let time = now.toLocaleTimeString('en-GB', { hour12: false }).replace(/:/g, '-'); // Format: HH-MM-SS
            const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
            let randomCode = '';
            for (let i = 0; i < 8; i++) {
                const randomIndex = Math.floor(Math.random() * allChars.length);
                randomCode += allChars[randomIndex];
            }

            let originalFile, customFileName, customFile;
            if (formData.document) {
                originalFile = formData.document;
                customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
                customFile = new File([originalFile], customFileName, { type: originalFile.type });
                formDataToSend.append("document", customFile);
            }

            try {
                let res = await axios.post(`${BASE_URL}/ticket/ticketChat/`, formDataToSend, {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        setUploadProgress(percentCompleted);
                    },
                },
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    });

                if (res.status === 200) {
                    await getTicketChat();
                    setFileName("");
                    handleClear();
                    setFormData({
                        ...formData,
                        message: "",
                        files: '',
                        document: null
                    });
                } else {
                    alert(res);
                }
            } catch (err) {
                // handleAllError(err, loadingToastId);
                handleAllError(err);
            } finally {
                setLoading(false);
                // toast.dismiss(loadingToastId);
            }
        }
    };
    // const handleSendTaskRemark = async (e) => {
    //     e.preventDefault();

    //     console.log("formData");
    //     console.log(formData);

    //     if (validateForm()) {
    //         setLoading(true);
    //         const loadingToastId = toast.loading("Loading: Please wait...");


    //         const formDataToSend = new FormData();
    //         Object.keys(formData).forEach((key) => {
    //             if (formData[key] && key !== "document") {
    //                 formDataToSend.append(key, formData[key]);
    //             }
    //         });

    //         const symbols = '!@#$%^&*()_-+=';
    //         const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz';
    //         const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    //         const numbers = '0123456789';
    //         const now = new Date();
    //         let date = now.toLocaleDateString('en-GB').split('/').reverse().join('-'); // Format: YYYY-MM-DD
    //         let time = now.toLocaleTimeString('en-GB', { hour12: false }).replace(/:/g, '-'); // Format: HH-MM-SS
    //         const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
    //         let randomCode = '';
    //         for (let i = 0; i < 8; i++) {
    //             const randomIndex = Math.floor(Math.random() * allChars.length);
    //             randomCode += allChars[randomIndex];
    //         }
    //         let originalFile
    //         let customFileName
    //         let customFile
    //         if (formData.document) {
    //             originalFile = formData.document;
    //             customFileName = Aimantra ${date} ${time}_${randomCode} ${originalFile.name};
    //             customFile = new File([originalFile], customFileName, { type: originalFile.type });
    //             formDataToSend.append("document", customFile);
    //         }


    //         try {
    //             let res = await axios.post(${BASE_URL}/ticket/ticketChat/, formDataToSend, {
    //                 headers: {
    //                     "Content-Type": "multipart/form-data",
    //                 },
    //             });

    //             if (res.status === 200) {
    //                 await getTicketChat();
    //                 setFormData({
    //                     ...formData,
    //                     message: "",
    //                     files: '',
    //                 });

    //                 // setChatShow(false);
    //                 // refreshData();
    //             } else {
    //                 alert(res);
    //             }
    //         } catch (err) {
    //             // alert(err);
    //             handleErrorToast(err, loadingToastId);
    //         } finally {
    //             setLoading(false);
    //             toast.dismiss(loadingToastId);
    //         }
    //     }
    // };

    // !########################################################################

    const [ticketChat, setTicketChat] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic
    const getFileNameFromLink = (url) => {
        try {
            const ImgFileUrl = "https://cipl-aimantra.s3.amazonaws.com/" || "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
            // const ImgFileUrl = "https://cipl-aimantra.s3.amazonaws.com/" || "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";

            if (url.startsWith(ImgFileUrl)) {
                const pathAfterBase = url.slice(ImgFileUrl.length);

                const fileName = pathAfterBase.split('/').slice(1).join('/').split('?')[0];

                return fileName;
            }

            return url;
        } catch (error) {
            console.error("Error extracting file name:", error);
            // handleErrorToast(error)
            return "";
        }
    };
    const getTicketChat = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/ticket/ticketChat-by-ticket/${i}/`
            );
            setTicketChat(res.data);
        } catch (err) {
            handleAllError(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        // Scroll to the bottom whenever new messages arrive
        if (chatboxRef.current) {
            chatboxRef.current.scrollTop = chatboxRef.current.scrollHeight;
        }
    }, [ticketChat]); // Runs whenever ticketChat updates

    return (
        <>
            <button onClick={() => handleChatOpen(i)}>
                <Chats />
            </button>

            <Modal
                show={chatShow}
                onHide={handleChatClose}
                dialogClassName="request-leave "
            >
                <Modal.Header closeButton>
                    <Modal.Title>Ticket Chat History</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="flex-column ">
                        <ul className="chatbox" ref={chatboxRef} style={{ overflowY: "auto", maxHeight: "500px" }}>
                            {buffer ? <div className="spinner-z"></div> : null}
                            {ticketChat.length === 0 ? (
                                <div className="align-center justify-center" style={{ alignSelf: "center" }}>
                                    - No Chat Historys 🪹 -
                                </div>
                            ) : (
                                ticketChat
                                    .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
                                    .map((i, index) => (
                                        <div key={index}>
                                            {i.sender === sessionStorage.getItem("email") ? (
                                                <>
                                                    <p className="chat-reply-timestamp font-size-text">{i.sender_name}</p>
                                                    <div className="chat chat-reply" style={{ padding: "10px" }}>
                                                        <li className="p-li">
                                                            {i.message ? <p>{i.message}</p> : <ViewChatImageorFile textcss="chat-photo-reply" filesrc={i.document} />}
                                                        </li>
                                                        <p className="chat-reply-timestamp pad-r text-right font-size-label">
                                                            {formatDateTime(i.timestamp).full}
                                                        </p>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <p className="chat-incoming-timestamp font-size-text">{i.sender_name}</p>
                                                    <div className="chat chat-incoming">
                                                        <li className="p-li">
                                                            {i.message ? <p>{i.message}</p> : <ViewChatImageorFile textcss="chat-photo-incoming" filesrc={i.document} />}
                                                        </li>
                                                        <p className="chat-incoming-timestamp pad-r text-right font-size-label">
                                                            {formatDateTime(i.timestamp).full}
                                                        </p>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    ))
                            )}
                        </ul>
                        {(status !== "completed" && usedIn !== "Raise Ticket") ?
                            <div>
                                <div className="flex-row justify-betweeen chat-input"
                                    style={{ height: "43px" }}
                                >

                                    {formData.document ?
                                        <>
                                            <div className="chat-input-textarea">
                                                {fileName && <p style={{ margin: "0px" }}>{fileName}</p>}
                                            </div>
                                            <button className="chat-clear" onClick={handleClear}>Clear</button>
                                        </>
                                        :
                                        <textarea
                                            id="message"
                                            name="message"
                                            maxLength={500}
                                            placeholder="Enter Message"
                                            onChange={handleInputChange}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" && !e.shiftKey) {
                                                    e.preventDefault();
                                                    handleSendTaskRemark();
                                                }
                                            }}
                                            value={formData.message}
                                            style={{ height: "20px", minHeight: "20px", resize: "vertical" }}
                                            className={`textarea-custom ${errors.message ? "textarea-error" : inputState.message ? "textarea-success" : ""}`}
                                        />
                                    }

                                    {formData.document && (
                                        <div>
                                            <span>{formData.document.fileName}</span>
                                            {formData.document.previewUrl && (
                                                <img src={formData.document.previewUrl} alt="File Preview" width={100} />
                                            )}
                                        </div>
                                    )}

                                    <div className="btn-cont align-end gap-const">
                                        <label htmlFor="document" >
                                            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20 7V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M18 18V12.5C18 11.6716 18.6716 11 19.5 11C20.3284 11 21 11.6716 21 12.5V18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18V14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            <input
                                                id="document"
                                                name="document"
                                                type="file"
                                                accept=".pdf, .doc, .docx, .png, .jpeg, .jpg"
                                                onChange={handleFileChange}
                                                ref={fileInputRef}
                                                style={{ display: "none", position: "relative" }}

                                                className={`  ${errors.document ? "error" : inputState.document ? "success" : ""
                                                    }`}
                                            />
                                        </label>

                                        <button onClick={handleSendTaskRemark} disabled={loading}>
                                            <ArrowBulletHead />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            : status !== "completed" && usedIn === "Raise Ticket" && email === "abhishek@aimantra.co" ?
                                <div>
                                    <div className="flex-row justify-betweeen chat-input"
                                        style={{ height: "43px" }}
                                    >

                                        {formData.document ?
                                            <>
                                                <div className="chat-input-textarea">
                                                    {fileName && <p style={{ margin: "0px" }}>{fileName}</p>}
                                                </div>
                                                <button className="chat-clear" onClick={handleClear}>Clear</button>
                                            </>
                                            :
                                            <textarea
                                                id="message"
                                                name="message"
                                                maxLength={500}
                                                placeholder="Enter Message"
                                                onChange={handleInputChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter" && !e.shiftKey) {
                                                        e.preventDefault();
                                                        handleSendTaskRemark();
                                                    }
                                                }}
                                                value={formData.message}
                                                style={{ height: "20px", minHeight: "20px", resize: "vertical" }}
                                                className={`textarea-custom ${errors.message ? "textarea-error" : inputState.message ? "textarea-success" : ""}`}
                                            />
                                        }

                                        {formData.document && (
                                            <div>
                                                <span>{formData.document.fileName}</span>


                                                {formData.document.previewUrl && (
                                                    <img src={formData.document.previewUrl} alt="File Preview" width={100} />
                                                )}
                                            </div>
                                        )}

                                        <div className="btn-cont align-end gap-const">
                                            <label htmlFor="document" >
                                                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M20 7V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M18 18V12.5C18 11.6716 18.6716 11 19.5 11C20.3284 11 21 11.6716 21 12.5V18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18V14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                <input
                                                    id="document"
                                                    name="document"
                                                    type="file"
                                                    accept=".pdf, .doc, .docx, .png, .jpeg, .jpg"
                                                    onChange={handleFileChange}
                                                    onFocus={handleClear}
                                                    style={{ display: "none", position: "relative" }}

                                                    className={`  ${errors.document ? "error" : inputState.document ? "success" : ""
                                                        }`}
                                                />
                                            </label>

                                            <button onClick={handleSendTaskRemark} disabled={loading}>
                                                <ArrowBulletHead />
                                            </button>
                                        </div>
                                    </div>
                                </div> :
                                <p className="text-center">
                                    {usedIn === "Raise Ticket" ? "Chat History" : "Task Completed"}
                                </p>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {errors.message && (
                        <span className="error-message font-size-text ">
                            {errors.message}
                        </span>
                    )}
                    {(uploadProgress > 0 && uploadProgress < 100) && (
                        <div className="progress-bar">
                            <div className="progress-bar-fill" style={{ width: `${uploadProgress}%` }}></div>
                            <span className="progress-text">{uploadProgress}%</span>
                        </div>
                    )}
                </Modal.Footer>
            </Modal>
            {/* <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover /> */}
        </>
    );
};

export { CompleteTask, CloseTask, TaskChatboxModal };
